import { useState } from 'react'
import { api } from 'lib/axios'
import { toast } from 'react-hot-toast'

const updateCreditCardImageWithMask = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/update-credit-card-image',
    payload
  )
  return response.data
}

const applyVaultRedactionRequest = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/apply-vault-redaction',
    payload
  )
  return response.data
}

export const useCreditCardMask = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleUpdateCreditCardImageWithMask = async payload => {
    setIsSubmitting(true)
    try {
      const response = await updateCreditCardImageWithMask(payload)

      if (response && !response.errors) {
        toast.success('Credit card image masked successfully!')
        return response
      } else {
        const errorMessage =
          response?.errors?.detail ||
          response?.message ||
          'Failed to update credit card image with mask'
        toast.error(errorMessage)
        throw new Error(errorMessage)
      }
    } catch (error) {
      let errorMessage =
        error?.response?.data?.errors?.detail ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.response?.data?.errors?.message ||
        error?.message ||
        'Failed to update credit card image with mask'

      if (
        errorMessage.includes('not found') ||
        errorMessage.includes('Credit card image document not found')
      ) {
        errorMessage =
          'Document not found. Please ensure the credit card image is properly uploaded and associated with this card.'
      }

      toast.error(errorMessage)
      throw error
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleApplyVaultRedaction = async payload => {
    setIsSubmitting(true)
    try {
      const response = await applyVaultRedactionRequest(payload)

      if (response && !response.errors) {
        toast.success('Vault image redaction applied successfully!')
        return response
      } else {
        const errorMessage =
          response?.errors?.detail ||
          response?.message ||
          'Failed to apply vault image redaction'
        toast.error(errorMessage)
        throw new Error(errorMessage)
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.detail ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.response?.data?.errors?.message ||
        error?.message ||
        'Failed to apply vault image redaction'

      toast.error(errorMessage)
      throw error
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    handleUpdateCreditCardImageWithMask,
    handleApplyVaultRedaction,
    isSubmitting
  }
}
